import type { FaireProductEntity } from "../../entity_types/product";

export const p_yuweerx42e: FaireProductEntity = {
  token: "p_yuweerx42e",
  type: "product",
  name: "Yoga peach juice 3x200ml",
  brandToken: "b_vsezuurgak",
  brandName: "Made in eatalia",
  imageUrl: "https://cdn.faire.com/fastly/0f9b0c6b974d5213b73dfee4cd100a6c20626aadec6674da5f93ec664e4cfa8a.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.42,
  description: "Savor the taste of Yoga Peach Juice, brought to you by Made in Eatalia. Each pack contains 3x200ml of juice, made from ripe, succulent peaches. This juice is a delightful treat, perfect for any time of the day. Enjoy it chilled for a unique taste. Made in Eatalia, your source for authentic Italian goods, brings you this delicious juice.",
  tags: [],
  msrpDollars: 5.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:11.359Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
